/* ============
 * Actions for the auth module
 * ============
 *
 * The actions that are available on the
 * auth module.
 */

// import Vue from 'vue';
// import store from '@/store';
// import * as types from './mutation-types';
/*
import API from '@/api/';
export const fetchPlanList = ({
  commit
}) => {
  return new Promise((resolve) => {
    API.plan.fetchPlanList().then(res => {
      if (res.status === 200) {
        commit(`plan/SET_PLANLIST`, {
          items: res.data
        }, {
          root: true
        })
        resolve(res)
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }
    })
  });
};
*/
import API from '@/api/'
export const batch = ({ commit }, params) => {
  return new Promise((resolve) => {
    API.audio.batch(params).then(res => {
      resolve(res);
    })
  })
}
export const batchDelete = ({ commit }, params) => {
  return new Promise((resolve) => {
    API.audio.batchDelete(params).then(res => {
      resolve(res);
    })
  })
}
export const list = ({ commit },params) => {
  return new Promise((resolve) => {
    API.audio.list(params).then(res => {
      if (res.status === 200) {
        commit(`audio/SET_LIST`, res.data.data, {
          root: true
        });
        commit(`audio/SET_TOTAL`, res.data.total, {
          root: true
        });
        commit(`audio/SET_OFFSET`, res.data.offset, {
          root: true
        });
        commit(`audio/SET_MAX`, res.data.max, {
          root: true
        });
        resolve(res)
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }

    })
  })
}
export const add = ({ commit },params) => {
  return new Promise((resolve) => {
    API.audio.add(params).then(res => {
      if (res.status === 201) {
        resolve(res)
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }

    })
  })
}
export const update = ({ commit },params) => {
  return new Promise((resolve) => {
    API.audio.update(params).then(res => {
      if (res.status === 200) {
        resolve(res)
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }

    })
  })
}
export const remove = ({ commit },params) => {
  return new Promise((resolve) => {
    API.audio.remove(params).then(res => {
      if (res.status === 200) {
        resolve(res)
      } else {
        // Message({
        //   message: res.data.message,
        //   type: 'error',
        //   duration: 10 * 1000
        // })
      }

    })
  })
}
export const clear = ({ commit }) => {
  return new Promise((resolve) => {
    commit(`audio/CLEAR`,{}, {
      root: true
    });
    resolve();
  })
}
export default {
  list,
  add,
  update,
  remove,
  batch,
  batchDelete,
  clear
};